import { render, staticRenderFns } from "./NowButton.vue?vue&type=template&id=1432e9fc&"
import script from "./NowButton.vue?vue&type=script&lang=ts&"
export * from "./NowButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports